import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { history } from "../../helper/history";
//import { countryService } from "../../services/country";
import { userService } from "../../services/user";
//import { listService } from "../../services/lists";
import { addressService } from "../../services/address";

export const addressActions = {
    updatePermission,
    getAddressesPagination,
    storeAddress,
    deleteAddress,
    getAddressItem,
    editAddress,
    getAllShippingAddresses,
    getAllBillingAddresses
};

function updatePermission(userId) {
    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function () {
                    history.go(0);
                }, 500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_FAILURE,
            payload: error
        };
    }
}

function editAddress(data, id) {
    return dispatch => {
        return addressService.editAddress(data, id).then(
            response => {
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getAddressesPagination(
    id,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return dispatch => {
        addressService
            .getAddressesPagination(
                id,
                page,
                sort,
                pageSize,
                component_name,
                pagination
            )
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_BRAND_ADDRESSES_SUCCESS,
                        payload: response
                    });
                },
                error => {
                    dispatch({
                        type: adminConstants.PAGINATION_BRAND_ADDRESSES_FAILURE,
                        payload: error
                    });
                }
            );
    };
}

function getAllShippingAddresses() {
    return dispatch => {
        addressService.getAllShippingAddresses().then(
            response => {
                dispatch({
                    type: adminConstants.GET_SHIPPING_ADDRESSES_SUCCESS,
                    payload: response.result.address
                });
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getAllBillingAddresses() {
    return dispatch => {
        addressService.getAllBillingAddresses().then(
            response => {
                dispatch({
                    type: adminConstants.GET_BILLING_ADDRESSES_SUCCESS,
                    payload: response.result.address
                });
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}

function storeAddress(data) {
    return dispatch => {
        return addressService.storeAddress(data).then(response => {
            dispatch({
                type: adminConstants.STORE_BRAND_ADDRESS_SUCCESS,
                payload: response
            });
            dispatch(alertActions.success(response.message));
            return data;
        },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function deleteAddress(list_id) {
    return dispatch => {
        return addressService.deleteAddress(list_id).then(
            response => {
                dispatch({
                    type: adminConstants.DELETE_BRAND_ADDRESS_SUCCESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getAddressItem(id) {
    return dispatch => {
        return addressService.getAddressItem(id).then(
            list => {
                dispatch({
                    type: adminConstants.GET_BRAND_ADDRESS_ITEM_SUCCESS,
                    payload: list
                });
            },
            error => {
                dispatch({
                    type: adminConstants.GET_ADDRESS_ITEM_FAILURE,
                    payload: error
                });
                dispatch(alertActions.error(error));
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/address-actions.jsx